import { useMutation, useQueryClient } from "@tanstack/react-query";
import { shippingInfosMutationApi } from "@/shared/api/shipping-infos/mutation";
import { ShippingInfoRequestBody } from "@/shared/api/shipping-infos/types";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

// 배송지 추가 — 성공 안내 UI는 호출부가 담당한다.
// 훅명이 useCreateShippingInfo가 아닌 이유: legacy SWR 훅
// (features/my-account/hooks/use-create-shipping-info.ts)과 이름이 겹쳐 혼동된다.
const usePostShippingInfo = (buyerId?: number) => {
  const { companyId, companyType } = useCompanyIdentity();
  const targetBuyerId = buyerId ?? companyId;
  const queryClient = useQueryClient();
  const { error } = useAppToasts({ id: "GLOBAL" });

  return useMutation({
    mutationFn: (body: ShippingInfoRequestBody) =>
      shippingInfosMutationApi.createShippingInfo(
        // companyTypeRequestFormatConverter가 Partial<Record>라 타입상 undefined가 섞인다.
        // useCompanyIdentity가 이미 BUYER로 폴백하므로 실제로는 undefined가 오지 않는다.
        companyType ?? "buyers",
        companyId as number,
        body
      ),
    onSuccess: () => {
      // 목록 조회와 같은 buyer id 기준 키를 무효화해야 한다.
      // is_default를 켜서 추가하면 기존 기본 배송지가 서버에서 강등되므로
      // 낙관적 패치 대신 목록 전체를 다시 받는다.
      // legacy SWR 소비처(useListShippingInfos)는 별도 캐시라 여기서 갱신되지 않는다.
      queryClient.invalidateQueries({
        queryKey: ["shipping-infos", targetBuyerId],
      });
    },
    onError: (err) => {
      error(err);
    },
  });
};

export default usePostShippingInfo;
